import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";

import ClearIcon from "@mui/icons-material/Clear";

import logo from "../../../../../../Assets/assetsnew/backend_logo_with_name.webp";
import rocketImg from "../../../../../../Assets/frontendImages/rocket.svg";

import Colors from "../../../../../../Constants/Colors";

function RedirectingModal({ show, onClose, onCloseSignModal }) {
  const [seconds, setSeconds] = useState(7);
  const history = useHistory();

  useEffect(() => {
    if (seconds < 0) return history.push("/db/signup");

    const id = setInterval(() => {
      setSeconds((seconds) => --seconds);
    }, 1000);

    return () => clearInterval(id);
  }, [seconds]);

  return (
    <Modal show={show} centered onHide={onClose} fullscreen>
      <div className="d-flex align-items-center justify-content-between p-3 p-md-4">
        <Link to="/">
          <img style={{ maxWidth: 200 }} src={logo} alt="zodot logo" />
        </Link>

        <ClearIcon
          sx={{
            color: Colors.font2,
            cursor: "pointer",
            alignSelf: "flex-start",
            opacity: 0.7,
            "&:hover": {
              opacity: 1,
            },
          }}
          onClick={() => {
            onClose();
            onCloseSignModal();
          }}
        />
      </div>

      <div
        style={{ height: "calc(100vh - 150px)" }}
        className="d-flex flex-column justify-content-center align-items-center px-3"
      >
        <img
          className="mb-3"
          src={rocketImg}
          alt="rocket img"
          style={{ maxWidth: 350 }}
        />

        <p className="fw-medium fs-4">Hold on!</p>

        <p className="text-center">
          You're being redirected to Zodot Signup Page - {seconds}{" "}
          {seconds > 1 ? "seconds" : "second"}.
        </p>
      </div>
    </Modal>
  );
}

export default RedirectingModal;
